module.exports = __webpack_public_path__ + "static/img1f-2996d1421fdcc19c9cf8f6af9733cb58.jpg";